import { useTranslation } from "react-i18next";
import type { Fixation } from "../../types/gazeHeatmapTypes";

function formatTime(seconds: number): string {
  if (seconds < 60) {
    return `${seconds.toFixed(1)}s`;
  }
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

function formatDuration(ms: number): string {
  if (ms < 1000) {
    return `${Math.round(ms)}ms`;
  }
  const seconds = ms / 1000;
  if (seconds < 60) {
    return `${seconds.toFixed(1)}s`;
  }
  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);
  return `${mins}m ${secs}s`;
}

interface FixationTooltipProps {
  fixation: Fixation;
}

const FixationTooltip = ({ fixation }: FixationTooltipProps) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: "absolute",
        bottom: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        marginBottom: "8px",
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        color: "white",
        padding: "8px 12px",
        borderRadius: "8px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
        zIndex: 1000,
      }}
    >
      <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
        {t("statsNew.scanpath.fixation")} #{fixation.id + 1}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "2px", opacity: 0.9 }}>
        <span>
          ⏱ {t("statsNew.scanpath.startTime")}: {formatTime(fixation.startTime)}
        </span>
        <span>
          ⏳ {t("statsNew.scanpath.duration")}: {formatDuration(fixation.duration)}
        </span>
        <span>
          👁 {t("statsNew.scanpath.points")}: {fixation.pointCount}
        </span>
        <span>
          💪 {t("statsNew.scanpath.strength")}: {Math.round(fixation.strength * 100)}%
        </span>
      </div>
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: "6px solid rgba(0, 0, 0, 0.9)",
        }}
      />
    </div>
  );
};

export default FixationTooltip;
